module.exports = __webpack_public_path__ + "static/media/16UNODC30.6c895d28.jpg";